import { HttpClient } from '@angular/common/http';
import {
    TRANSLOCO_LOADER,
    Translation,
    TranslocoLoader,
    TRANSLOCO_CONFIG,
    translocoConfig,
    TranslocoModule,
    provideTransloco,
} from '@jsverse/transloco';
import { Injectable, NgModule, isDevMode } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string) {
        return this.http.get<Translation>(`assets/i18n/${lang}.json`);
    }
}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                // Remove this option if your application doesn't support changing language in runtime.
                availableLangs: ['en', 'de'],
                defaultLang: 'en',
                reRenderOnLangChange: true,
                prodMode: environment.production,
                fallbackLang: 'en',
                missingHandler: {
                    useFallbackTranslation: true,
                },
            },
            loader: TranslocoHttpLoader,
        }),
    ],
})
export class TranslocoRootModule {}
